import React, { Component } from "react";
import KickImage from 'Reuseables/KickImage';
import { Container, Row, Col } from "reactstrap";
// import Sneaker from '../Sneakers/Sneaker';

const benefitFeaturesContent = {
  sneakers: [
    {
      title: "Thousands of sneakers.",
      paragraph:
        "We have thousands of sneakers for you to pick from. Efficiently sort and filter to find exactly what you're after."
    },
    {
      title: "Buy without worry.\nAuthenticity is Guaranteed.",
      paragraph:
        "Every purchase includes FREE authentication/legit-checking from our team of experts. Fakes will never reach your doorstep."
    },
    {
      title: "True after-market price",
      paragraph:
        "Our marketplace ecosystem is highly competitive. Sellers compete to have the lowest price whilst buyers compete to have the highest offer. This reveals the true value of our products."
    }
  ],
  apparels: [
    {
      title: "Thousands of streetwear variants.",
      paragraph: "Find wide selections of trending streetwear in our database."
    },
    {
      title: "Authentic. Guaranteed.",
      paragraph: "Every purchase will be thoroughly checked and guaranteed."
    },
    {
      title: "Data driven market price.",
      paragraph: "Get a fair market price for every item listed."
    }
  ],
  handbags: [
    {
      title: "Thousands of stylish handbag.",
      paragraph: "Discover wide selections of stylish handbag in our platform."
    },
    {
      title: "Authentic. Guaranteed.",
      paragraph: "We guarantee your style with authentic product."
    },
    {
      title: "Highly competitive price.",
      paragraph: "Get stylish handbag with competitive price as you wish."
    }
  ],
  lifestyles: [
    {
      title: "Hundreds of lifestyle products.",
      paragraph: "Keep yourself updated with hundreds of lifestyle products."
    },
    {
      title: "Authentic. Guaranteed.",
      paragraph: "We guarantee your lifestyle with authentic product."
    },
    {
      title: "Fair market price.",
      paragraph: "Get a fair market price for every item listed."
    }
  ]
};

class BenefitFeatures extends Component {
  _renderData = () => {
    const category = this.props.category && this.props.category.toLowerCase();

    return (
      benefitFeaturesContent[category] &&
      benefitFeaturesContent[category].map((item, key) => {
        let newTitle = item.title.split("\n").map((item, i) => {
          return (
            <span key={i}>
              {item}
              <br />
            </span>
          );
        });
        return (
          <Col key={key} xs="12" sm="12" md={4} className="col-text">
            <div className="feature">
              <p className="feature-text">{newTitle}</p>
              <p className="feature-text__inverse">{item.paragraph}</p>
            </div>
          </Col>
        );
      })
    );
  };

  render() {
    return (
      <Container fluid className="features-text-container">
        <Row className="features-bottom">{this._renderData()}</Row>
      </Container>
    );
  }
}

export default BenefitFeatures;
